import { render, staticRenderFns } from "./BeneficiaryAddLayout.vue?vue&type=template&id=8e4f468a&scoped=true&"
import script from "./BeneficiaryAddLayout.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryAddLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4f468a",
  null
  
)

export default component.exports